import { STORAGE_KEYS } from '@constants/storageKeys';

export const THEME_MODES = {
  SYSTEM: 'system',
  LIGHT: 'light',
  DARK: 'dark'
};

export function isThemeMode(value) {
  return Object.values(THEME_MODES).includes(value);
}

export function readThemeMode(storage = globalThis.localStorage) {
  const saved = storage.getItem(STORAGE_KEYS.THEME_PREFERENCE);
  return isThemeMode(saved) ? saved : THEME_MODES.SYSTEM;
}

export function resolveTheme(themeMode, systemPrefersDark, themes) {
  if (themeMode === THEME_MODES.LIGHT) return themes.light;
  if (themeMode === THEME_MODES.DARK) return themes.dark;
  return systemPrefersDark ? themes.dark : themes.light;
}
